export default {
  addCompany(state, { company, organizationNumber }) {
    state.companies = {
      ...state.companies,
      [organizationNumber]: company
    };
  }
};
